/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Open_MenuInputs */

const en_nav_open_menu = /** @type {(inputs: Nav_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open menu`)
};

const zh_hans1_nav_open_menu = /** @type {(inputs: Nav_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开菜单`)
};

const pt_br2_nav_open_menu = /** @type {(inputs: Nav_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir menu`)
};

const es_nav_open_menu = /** @type {(inputs: Nav_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir menú`)
};

const fr_nav_open_menu = /** @type {(inputs: Nav_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le menu`)
};

const de_nav_open_menu = /** @type {(inputs: Nav_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü öffnen`)
};

const ru_nav_open_menu = /** @type {(inputs: Nav_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть меню`)
};

const it_nav_open_menu = /** @type {(inputs: Nav_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri il menu`)
};

/**
* | output |
* | --- |
* | "Open menu" |
*
* @param {Nav_Open_MenuInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const nav_open_menu = /** @type {((inputs?: Nav_Open_MenuInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Open_MenuInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_nav_open_menu(inputs)
	if (locale === "pt-BR") return pt_br2_nav_open_menu(inputs)
	if (locale === "es") return es_nav_open_menu(inputs)
	if (locale === "fr") return fr_nav_open_menu(inputs)
	if (locale === "de") return de_nav_open_menu(inputs)
	if (locale === "ru") return ru_nav_open_menu(inputs)
	if (locale === "it") return it_nav_open_menu(inputs)
	return en_nav_open_menu(inputs)
});